__turbopack_context__.v({
  "body": "CollectionCard-module-scss-module__MDQcRW__body",
  "card": "CollectionCard-module-scss-module__MDQcRW__card",
  "eventCount": "CollectionCard-module-scss-module__MDQcRW__eventCount",
  "eventCountSkeleton": "CollectionCard-module-scss-module__MDQcRW__eventCountSkeleton",
  "eventCountUnavailable": "CollectionCard-module-scss-module__MDQcRW__eventCountUnavailable",
  "image": "CollectionCard-module-scss-module__MDQcRW__image",
  "imageWrapper": "CollectionCard-module-scss-module__MDQcRW__imageWrapper",
  "shareSlot": "CollectionCard-module-scss-module__MDQcRW__shareSlot",
  "summary": "CollectionCard-module-scss-module__MDQcRW__summary",
  "title": "CollectionCard-module-scss-module__MDQcRW__title",
  "titleLink": "CollectionCard-module-scss-module__MDQcRW__titleLink",
});
